<template>
  <div class="product-detail-page-5">
    <!-- 商品总的描述 -->
    <div class="top-section flex-between">
      <!-- 左边主要内容 -->
      <div class="left-content flex-rowl">
        <div class="image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/10/5435525302670567608.jpg?v=01"
            class="zoomable-image"
          />
        </div>
        <div class="text-content">
          <h1 class="title">{{ $t('productDetail5.title') }}</h1>
          <h2 class="sub_title">{{ $t('productDetail5.subTitle') }}</h2>
          <div class="description">
            <p class="txt2 mb_40">
              {{ $t('productDetail5.description.para1') }}
            </p>
            <p class="txt1 mb_30">{{ $t('productDetail5.description.usageTitle') }}</p>
            <p class="txt2" v-html="$t('productDetail5.description.usageContent')"></p>
          </div>
          <div
            class="more-details-wrap"
            @mouseenter="showQRCode = true"
            @mouseleave="showQRCode = false"
          >
            <button class="more-details-btn flex-rowl">
              {{ $t('productDetail5.consultationButton') }}
              <i class="iconfont icon-xiangxiajiantou"></i>
            </button>
            <div class="more-details-ercode flex-colc" v-show="showQRCode">
              <div class="ercode_img">
                <img
                  src="https://upload.vwingist.com/melscn/0image/2025/05/4947680805527964914.png"
                  alt=""
                />
              </div>
              <div class="ercode_txt flex-colc">
                <p v-html="$t('productDetail5.qrCodeInfo.text1')"></p>
                <p v-html="$t('productDetail5.qrCodeInfo.text2')"></p>
                <p>{{ $t('productDetail5.qrCodeInfo.text3') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边商品分类折叠面板 -->
      <ProductCategoryPanel />
    </div>
    <!-- 商品详细描述 -->
    <div class="bottom-section">
      <div
        v-for="(item, index) in detailItems"
        :key="index"
        :class="[
          'bottom-section-list flex-between',
          item.length == 2 ? 'new-class-2' : '',
          item.length == 3 ? 'new-class-3' : '',
        ]"
      >
        <div
          class="detail-item"
          v-for="(itemChild, indexChild) in item"
          :key="indexChild"
        >
          <div class="top-part flex-between">
            <div class="left-text">
              <h2 class="sub-title">{{ $t(`productDetail5.detailItems[${indexChild}].subTitle`) }}</h2>
              <p class="sub-description">{{ $t(`productDetail5.detailItems[${indexChild}].subDescription`) }}</p>
            </div>
            <div class="right-image image-container">
              <img :src="itemChild.imageUrl" class="zoomable-image"/>
            </div>
          </div>
          <div class="bottom-part">
            <h3 class="detail-title" v-html="$t(`productDetail5.detailItems[${indexChild}].detailTitle`)"></h3>
            <p class="detail-description" v-html="$t(`productDetail5.detailItems[${indexChild}].detailDescription`)"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCategoryPanel from "@/components/ProductCategoryPanel.vue";

export default {
  name: "ProductDetail1",
  components: {
    ProductCategoryPanel,
  },
  data() {
    return {
      showQRCode: false,
      detailItems: [
        [
          {
            subTitle: "鎖鮮防護",
            subDescription: "潤澤收官",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5082405180285347223.png",
            detailTitle: "",
            detailDescription:
              "慕斯質地輕盈包裹，將抗老成分牢牢鎖住，在肌膚表面形成透氣鎖水層。",
          },
          {
            subTitle: "持久保濕",
            subDescription: "提升妝效",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5211793761523345964.png",
            detailTitle: "",
            detailDescription:
              "72小時長效保濕，晨起肌膚如剝殼荔枝般水潤嫩滑，妝前使用更可提升底妝貼合度200%。",
          },
        ],
      ],
    };
  },
};
</script>

<style scoped lang="less">
.product-detail-page-5 {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .top-section {
    margin-bottom: 120px;
    align-items: flex-start;
    .left-content {
      width: 985px;
      flex-shrink: 0;
      align-items: flex-start;
      .image-container {
        width: 389px;
        height: 613px;
        margin-right: 50px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .text-content {
        flex: 1;
        color: #333333;
        .title {
          font-size: 26px;
          margin-bottom: 10px;
          font-family: "SourceHanSerifCN-Medium", sans-serif;
          font-weight: 600;
        }
        .sub_title {
          font-size: 24px;
          margin-bottom: 40px;
        }

        .description {
          .txt1 {
            font-size: 20px;
            font-family: "SourceHanSerifCN-Medium", sans-serif;
          }
          .txt2 {
            font-size: 18px;
            line-height: 30px;
            font-family: "SourceHanSerifCN-Light", sans-serif;
          }
          .mb_30 {
            margin-bottom: 30px;
          }
          .mb_40 {
            margin-bottom: 40px;
          }
        }

        .more-details-btn {
          width: 359px;
          height: 50px;
          border-radius: 0px 0px 0px 0px;
          border: 2px solid #000000;
          font-size: 16px;
          color: #000000;
          margin-top: 100px;
          cursor: pointer;
          position: relative;
          padding-left: 30px;
          box-sizing: border-box;
          background-color: #fff;
          .icon-xiangxiajiantou {
            position: absolute;
            right: 20px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .bottom-section {
    .bottom-section-list {
      align-items: flex-start;
      &.new-class-2 {
        padding-left: 110px;
        padding-right: 110px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 2);
        }
      }
      &.new-class-3 {
        margin-bottom: 100px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 3);
        }
      }
      .detail-item {
        padding-right: 47px;
        box-sizing: border-box;
        border-right: 1px dashed #999999;
        &:last-child {
          border-right: none;
        }
        .top-part {
          width: 370px;
          height: 150px;
          background: #f9f9f9;
          box-shadow: inset 0px 0px 16px 1px rgba(84, 79, 90, 0.1);
          border-radius: 75px 75px 75px 75px;
          margin-bottom: 50px;
          padding: 0 2px 0 27px;
          box-sizing: border-box;
          .left-text {
            color: #333333;
            flex: 1;
            .sub-title {
              font-size: 30px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
              margin-bottom: 10px;
              font-weight: 600;
            }
            .sub-description {
              font-size: 24px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
            }
          }
          .right-image {
            width: 145px;
            height: 145px;
            // border: 5px solid #fff;
            border-radius: 50%;
            box-sizing: border-box;
          }
        }
        .bottom-part {
          color: #333333;
          .detail-title {
            font-size: 24px;
            line-height: 34px;
            margin-bottom: 30px;
            font-family: "SourceHanSerifCN-Medium", sans-serif;
          }
          .detail-description {
            font-size: 16px;
            line-height: 28px;
            font-family: "SourceHanSerifCN-Light", sans-serif;
          }
        }
      }
    }
  }

  .more-details-wrap {
    position: relative;
    .more-details-ercode {
      width: 378px;
      height: 408px;
      background: url(https://upload.vwingist.com/melscn/0image/2025/04/5425508493632964248.png)
        no-repeat center;
      background-size: cover;
      position: absolute;
      bottom: -9px;
      left: 340px;
      z-index: 9999;
      .ercode_img {
        width: 230px;
        height: 230px;
        margin-bottom: 38px;
      }
      .ercode_txt {
        font-size: 16px;
        color: #333333;
        p {
          margin-bottom: 10px;
          font-family: "SourceHanSansCN-Light", sans-serif;
          span {
            font-family: "SourceHanSansCN-Medium", sans-serif;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>